import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import proveedorService from "../../../service/administracion/proveedorService";
import monedaService from "../../../service/administracion/monedaService";

import { FACTURA } from '../../../common/types/tipoComprobanteType';

import cuentasPagarService from '../../../service/tesoreria/cuentasPagar';
import auth from '../../../common/utility/auth';
import comprobanteService from '../../../service/ventas/comprobanteService';
import metodoPagoService from '../../../service/administracion/metodoPagoService.js';

//Service de Cobranzas
import bancoService from '../../../service/administracion/bancoService';

import pagoService from '../../../service/tesoreria/pagoService';
import empresaService from '../../../service/administracion/empresaService';

import cuentaService from '../../../service/administracion/cuentaService';
import Header from './Header';


import Filters from './Filters';
import ResultList from './ResultList';
import ResultListDetalle from './ResultListDetalle';

import ViewPago from './ViewPago';
import ViewPagoCredito from './ViewPagoCredito.js';
import SearchCreditoModal from './SearchCreditoModal';

import printFormatMock from '../../../common/mock/printFormatMock';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            viewVisible: false,
            viewPagoVisible: false,
            viewHistorialVisible: false,
            isRegresar: true,
            viewPagoCreditoVisible: false,
            viewCredito: false,
            company: {},
            isCabecera: true,
            ListCabecera: true,
            ListDetalle: false,
            isDisabled: false,
            isPagar: false,
            listaTipoComprobante: [
                { 'id': -1, 'nombre': 'SELECCIONAR DOCUMENTO' },
                { 'id': 2, 'nombre': 'Factura' },
                { 'id': 4, 'nombre': 'Boleta' },
                { 'id': 15, 'nombre': 'Recibo por servicios públicos' }
            ],

            clientes: [],
            listaEstadoPago: [],
            listaMetodoPago: [],
            listaCuentaDestino: [],
            listaBanco: [],
            listaCredito: [],
            listaMoneda: [],
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                serieCorrelativo: ''
            },

            viewFormValues: {},
            estados: estadoMock.values,
            filter: {
                idTipoComprobante: -1,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                proveedor: '',
                idProveedor: 0,
                idEstado: 0,
                estado: '',
                documento: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            activeKey: "3",
            nombre: "",
            identifier: '',
            IdApertura: 0,
            IdCaja: 0,
            idCuentasPagar: 0,
            idCuentasPagarDetalle: 0,
            DocumentoCliente: '',
            RazonSocialClientemento: '',
            Moneda: '',
            Total: 0,
            flagPago: false,
            flagCredito: false,
            Saldo: 0,
            Monto: 0,
            nroCouta: 0,
            nro_documento: '',
            tipoCambio: 0,
            Fecha: global.fetchCurrentDateStr(),
            listaFormaPago: [],
            listaFormaPagoCredito: [],
            listaFormaPagoOtros: [],
            listaMetodoPago: [],
            listaCuentaDestino: [],
            listaComprobanteMasivo: [],
            listaBanco: [],
            listaCredito: [],
            listaMoneda: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: -1,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            proveedor: '',
            idProveedor: 0,
            idEstado: 0,
            estado: '',
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value, name, proveedor) => {
        debugger
        const filter = { ...this.state.filter, [property]: value };


        this.setState({ filter });

    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await pagoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Pago a Proveedores.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await pagoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Pago a Proveedores.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await cuentasPagarService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    /******************** FORM MODAL *****************/

    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: FACTURA.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }



    handlePago = (value, row) => {
        debugger
        var detalleBancoFilter = this.state.formValues.listaBanco.filter((m) => {
            return m.id == value;
        });

        var detalleCuentaFilter = this.state.listaCuentaDestino.filter((m) => {
            return m.idEntidad == detalleBancoFilter[0].idEntidad;
        });

        console.log(detalleCuentaFilter);


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaCuentaDestino: detalleCuentaFilter,
            },
        });


    }



    onPagar = () => {
        this.setState({
            loadingVer: false,
            viewVisible: false,
            viewPagoVisible: true,
            isPagar: false,
        });
    };


    onReturn = () => {
        debugger

        this.handleClearFilters();

        setTimeout(() => {
            this.handleCabecera();
        }, 1000);

    };

    handleCabecera = () => {


        this.setState({
            isCabecera: true,
            ListCabecera: true,
            ListDetalle: false,
            isDisabled: false,
            isRegresar: true,

        });

    }


    handleSave = (values, form) => {
        debugger

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            response = await cuentasPagarService.registrar(values);


            if (response.status === 200) {
                form.resetFields();
                this.setState({ viewPagoVisible: false });
                message.success('Registrado' + ' correctamente.');
                this._handlePagination(this.state.filter);


                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    //#regional MODAL VIEW 

    handleView = async (item) => {
        debugger
        this.setState({ loadingVer: true });
        var response = await cuentasPagarService.ver({ id: item.id });
        if (response !== undefined) {

            console.log(item);

            this.setState({
                loadingVer: false,
                viewVisible: true,
                viewFormValues: {
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    FechaTipoCambio: item.fechaStr,
                    TipoCambio: item.tipoCambio,
                    Serie: item.nroSerie,
                    NumeroDocumento: item.serieDocumentoComprobante,
                    Correlativo: item.correlativo,
                    Dias: 0,
                    Monto: item.total,
                    Saldo: item.saldo,
                    ImporteCancelado: (item.total - item.saldo),
                    FechaVencimiento: global.fetchCurrentDateStr(),
                    Moneda: item.moneda,
                    detalles: response

                }
            });
        }
    }



    handleHistorial = (item) => {
        var idProveedor = this.state.clientes.filter(m => m.numeroDocumento === item.numeroDocumentoCliente)[0];
        debugger
        this.setState({
            filter: {
                ...this.state.filter,
                IdEstado: 0,
                IdProveedor: idProveedor.id
            },
            isDisabled: true
        });

        setTimeout(() => {
            this.handleDetalle()
        }, 100);


    }
    handleDetalle = async () => {

        var response = await pagoService.paginacion({ ...this.state.filter });

        if (response != null || response != undefined) {
            this.setState({
                pagination: response
            })

            this.setState({
                isCabecera: true,
                ListCabecera: false,
                ListDetalle: true,
                isRegresar: false,
            });
        }

    }



    handleChangeSelectedRowKey = (selected, rows) => {
        var isValido = true;
        var lista_todo = this.state.pagination.data;

        var lista_all = [];

        if (rows.length >= 2) {

            var IdDocumento = rows[0].id

            var dataExist = rows.filter(m => { return m.id == IdDocumento; });

            if (dataExist.length !== rows.length) {
                dialog.error("El documento seleccionado debe ser el mismo serie correlativo")

                this.setState({

                    isPagar: false,

                });

                return false;
            }

        }


        if (rows.length > 0)
            var totalCuotas = parseFloat(
                rows.reduce((a, b) => a + (b["montoCuota"] || 0), 0)
            );

        var metodo_pago = this.state.listaMetodoPago;
        var cuenta_destino = this.state.listaCuentaDestino;
        var listaBanco = this.state.listaBanco;

        var listaComprobanteMasivo = new Array();
        var listaFormaPago = new Array();

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteMasivo: listaComprobanteMasivo
            },
        });



        if (rows.length > 0) {
            var fila = rows[0].id;
            rows.forEach(item => {

                listaComprobanteMasivo.push({
                    idCuentasPagar: item.id,
                    idCuentasPagarDetalle: item.idCuentasPagarDetalle,
                    fecha: '',
                    idMetodoPago: 0,
                    idCuenta: 0,
                    referencia: 0,
                    total: 0,
                })

                listaFormaPago.push({
                    identifier: global.fetchUniqueCode(),
                    idCuentasPagar: item.id,
                    idCuentasPagarDetalle: item.idCuentasPagarDetalle,
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: 0,
                    idDestino: 0,
                    nroCouta: item.couta,
                    referencia: '',
                    montoCuota: item.montoCuota
                });

            });

            if (selected.length >= 2) {
                selected = selected.sort();


                lista_all = lista_todo.filter(m => m.id === fila);
                lista_all.forEach(function (data, index) {
                    var idSelected = selected[index];
                    if (idSelected === undefined || isValido == false) {
                        return false;
                    } else {
                        if (data.idCuentasPagarDetalle == idSelected) {
                            //console.log("CUOTA valido" + idSelected)
                        } else {
                            isValido = false;
                            dialog.error('No se puede realizar el pago ... Tiene que seleccionar cuotas en forma ordenada');
                            return false;
                        }
                    }

                });
            }



            this.setState({

                formValues: {
                    DocumentoCliente: rows[0].numeroDocumentoCliente,
                    RazonSocialClientemento: rows[0].razonSocialCliente,
                    Moneda: rows[0].moneda,
                    Monto: totalCuotas,
                    nroCouta: rows[0].couta.replace('CUOTA', ''),
                    Fecha: global.fetchCurrentDateStr(),
                    listaFormaPago: listaFormaPago,
                    listaMetodoPago: metodo_pago,
                    listaCuentaDestino: cuenta_destino,
                    listaComprobanteMasivo: listaComprobanteMasivo,
                    listaBanco: listaBanco
                }


            });

        }
        if (isValido) {
            this.setState({

                viewPagoDetalle: rows.length == 0 ? false : true,
                isPagar: rows.length <= 1 ? false : true,

            });
        } else {
            this.setState({
                isPagar: false,

            });
        }



    };


    handleViewPago = async (item) => {

        this.setState({ loadingPago: true });
        var filter = new Object();
        filter.idCuentasPagar = item.id;
        var _moneda = item.moneda.charAt(0);

        var response = await pagoService.pago_credito(filter);

        if (response.length > 1) {

            this.setState({
                loadingVer: false,
                viewVisible: false,
                viewPagoCreditoVisible: true,
                formValues: {
                    ...this.state.formValues,
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    idCuentasPagar: item.id,
                    activeKey: "3",
                    idCuentasPagarDetalle: item.idCuentasPagarDetalle,
                    Moneda: item.moneda,
                    Monto: _moneda == "S" ? (item.saldoSoles / item.tipoCambio) : (item.saldoSoles * item.tipoCambio),
                    nroCouta: item.couta,
                    Fecha: item.fechaStr,
                    tipoCambio: item.tipoCambio,
                    Total: _moneda == "S" ? item.totalSoles : item.totalSoles,
                    Saldo: _moneda == "S" ? item.saldoSoles : item.saldoSoles,
                    formaPago: item.formaPago,
                    flagPago: false,
                    flagCredito: item.idFormaPago == 2 ? true : false,
                    listaFormaPago: [],
                    flagDetraccion: item.flagDetraccion,
                    listaComprobanteMasivo: [],
                    listaFormaPagoCredito: [],
                    listaFormaPagoOtros: [],
                    tipoComprobante: item.tipoComprobante,
                    listaBanco: this.state.listaBanco,
                    listaMoneda: this.state.listaMoneda,
                    nro_documento: item.serieDocumentoComprobante,
                    listaDetalleCredito: response,
                }
            });

            return false;
        } else {


            this.setState({
                loadingVer: false,
                viewVisible: false,
                viewPagoVisible: true,
                formValues: {
                    ...this.state.formValues,
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    idCuentasPagar: item.id,
                    activeKey: "3",
                    idCuentasPagarDetalle: response[0].idCuentasPagarDetalle,
                    Moneda: item.moneda,
                    Monto: _moneda == "S" ? (item.saldoSoles / item.tipoCambio) : (item.saldoSoles * item.tipoCambio),
                    nroCouta: response[0].couta,
                    Fecha: item.fechaStr,
                    tipoCambio: item.tipoCambio,
                    Total: _moneda == "S" ? item.totalSoles : item.totalSoles,
                    Saldo: _moneda == "S" ? item.saldoSoles : item.saldoSoles,
                    flagPago: false,
                    flagCredito: response[0].idFormaPago == 2 ? true : false,
                    formaPago: item.formaPago,

                    listaFormaPago: [],
                    listaMetodoPago: this.state.listaMetodoPago,
                    listaCuentaDestino: this.state.listaCuentaDestino,
                    listaComprobanteMasivo: [],
                    listaFormaPagoCredito: [],
                    listaFormaPagoOtros: [],
                    tipoComprobante: item.tipoComprobante,
                    listaBanco: this.state.listaBanco,
                    listaMoneda: this.state.listaMoneda,
                    nro_documento: item.serieDocumentoComprobante,
                    flagDetraccion: response[0].flagDetraccion

                }
            });


        }
        this.setState({ loadingPago: false })

    }



    handleAddFormaPago = () => {

        var listaFormaPago = this.state.formValues.listaFormaPago;
        var listaFormaPagoCredito = this.state.formValues.listaFormaPagoCredito;
        var listaFormaPagoOtros = this.state.formValues.listaFormaPagoOtros;
        var montoSolesOtros = listaFormaPagoOtros.filter(e => e.idMoneda == 1).reduce((a, b) => a + (b["montoCuota"] || 0), 0);
        var montoSolesEfectivo = listaFormaPago.filter(e => e.idMoneda == 1).reduce((a, b) => a + (b["montoCuota"] || 0), 0);

        if (this.state.formValues.activeKey == "1") { //pago efectivo
            var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;

            if (listaFormaPago.length <= 1) {

                listaFormaPago.push({
                    identifier: global.fetchUniqueCode(),
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: this.state.formValues.activeKey == "1" ? 4 : 0,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: listaFormaPago.length == 0 ? moneda : (moneda == 1 ? 2 : 1),  //SOLES?DOLARES
                    referencia: '',
                    montoCuota: this.state.formValues.Saldo - montoSolesOtros,
                    montoRecibido: 0,
                    montoVuelto: 0
                });
            }


        }
        if (this.state.formValues.activeKey == "2") { //Pago credito
            listaFormaPagoCredito.push({
                identifier: global.fetchUniqueCode(),
                fecha: global.fetchCurrentDateStr(),
                idMetodoPago: this.state.formValues.activeKey == "1" ? 8 : 0,
                idDestino: 0,
                nroDocumento: '',
                idBanco: 0,
                idMoneda: 0,
                referencia: '',
                montoCuota: 0,
                montoRecibido: 0,
                montoVuelto: 0
            });

        }
        if (this.state.formValues.activeKey == "3") { //paog otros
            listaFormaPagoOtros.push({
                identifier: global.fetchUniqueCode(),
                fecha: global.fetchCurrentDateStr(),
                idMetodoPago: 0,
                idDestino: 0,
                nroDocumento: '',
                idBanco: 0,
                idMoneda: 0,
                referencia: '',
                montoCuota: this.state.formValues.Saldo - montoSolesEfectivo,
                montoRecibido: 0,
                montoVuelto: 0
            });

        }


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPago: listaFormaPago,
                listaFormaPagoOtros: listaFormaPagoOtros,
                listaFormaPagoCredito: listaFormaPagoCredito
            }
        });


    };




    handleRemoverFormaPago = (item) => {
        debugger
        var lista_FormaPago = this.state.formValues.listaFormaPago.filter(m => m.identifier !== item.identifier);
        var listaFormaPagoCredito = this.state.formValues.listaFormaPagoCredito.filter(m => m.identifier !== item.identifier);
        var listaFormaPagoOtros = this.state.formValues.listaFormaPagoOtros.filter(m => m.identifier !== item.identifier);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPago: lista_FormaPago,
                listaFormaPagoOtros: listaFormaPagoOtros,
                listaFormaPagoCredito: listaFormaPagoCredito
            }
        });


    };


    //#endregion MODAL


    //#region Imprimir


    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });
        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;

        if (idFormato === 1) {
            response = await cuentasPagarService.pdfA4({ id: item });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cuentasPagarService.ticket({ id: item });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cuentasPagarService.ticket50({ id: item });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            loadingImprimir: false,
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                idComprobante: item
            },
            selectedItem: item
        });
    };

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await cuentasPagarService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cuentasPagarService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cuentasPagarService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file
            }
        });
    };

    handleDownloadPdf = async () => {

        var response = undefined;
        var file = undefined;

        if (this.state.imprimirFormValues.idFormato === 1) {
            response = await cuentasPagarService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 2) {
            response = await cuentasPagarService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 3) {
            response = await cuentasPagarService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (response !== undefined)
            global.dowloadFile(response.data, this.state.viewFormValues.NumeroDocumento + ".pdf");
    };



    handleSelectProduct = (row) => {
        debugger
        var idNota = this.state.listaMetodoPago.filter(item => (item.nombre.toUpperCase()).charAt(0) == "N");

        var identifier = this.state.formValues.identifier;
        var listaFormaPagoCredito = this.state.formValues.listaFormaPagoCredito.filter(row => row.identifier != identifier);
        var date = this.state.formValues.listaFormaPagoCredito.filter(row => row.identifier == identifier);

        var listaCredito = listaFormaPagoCredito.filter(element => element.nroDocumento == row.nroDocumento);

        if (listaCredito.length > 0) {
            dialog.error('No se puede duplicar Nota de credito');

        } else {
            listaFormaPagoCredito.push({
                identifier: global.fetchUniqueCode(),
                fecha: date == undefined ? global.fetchCurrentDateStr() : date[0].fecha,
                idMetodoPago: idNota == undefined ? 6 : parseInt(idNota[0].id),
                idDestino: 0,
                nroDocumento: row.nroDocumento,
                idBanco: 0,
                idMoneda: row.moneda == "SOLES" ? 1 : 2,
                referencia: '',
                montoCuota: parseFloat(row.total),
                montoRecibido: 0,
                montoVuelto: 0
            });
            this.setState({
                formValues: {
                    ...this.state.formValues,

                    listaFormaPagoCredito: listaFormaPagoCredito
                }
            });
        }


    };

    onSwitch = (element) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                flagPago: element,
            },
        });

    }


    handleChangeTab = (key, onSetFieldsValue) => {

        if (key == "1") {
            // Referencias
            onSetFieldsValue({
                flagReferencia: true,
            });
        }
        if (key == "2") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }
        if (key == "3") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }


        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key,
            },
        });
    };



    handleChangePago = async (label, property, value, identifier, index) => {

        if (property == "idBanco") {
            var banco = this.state.listaBanco.filter(b => b.id == value);
            const cuentaDestino = await cuentaService.obtenerPorId(banco[0].idEntidad);

            this.setState({
                listaCuentaDestino: cuentaDestino ? cuentaDestino : [],
                formValues: {
                    ...this.state.formValues,
                    listaCuentaDestino: cuentaDestino ? cuentaDestino : [],
                    idDestino: 0
                }
            })

        }


        if (property == "fecha") {
            switch (this.state.formValues.activeKey) {
                case "1":
                    this.state.formValues.listaFormaPago.forEach(element => {
                        if (element.identifier == identifier) {
                            element.fecha = value;
                            return false;
                        }
                    });
                    break;
                case "2":
                    this.state.formValues.listaFormaPagoCredito.forEach(element => {
                        if (element.identifier == identifier) {
                            element.fecha = value;
                            return false;
                        }
                    });
                    break;
                case "3":
                    this.state.formValues.listaFormaPagoOtros.forEach(element => {
                        if (element.identifier == identifier) {
                            element.fecha = value;
                            return false;
                        }
                    });
                    break;
                default:
                    break;
            }

        }

        if (property == "idMetodoPago") {

            var isNota = label.split(" ")[0].toUpperCase();

            if (isNota == "NOTA") {

                var cliente = this.state.clientes.filter(e => e.numeroDocumento == this.state.formValues.DocumentoCliente);
                if (["01", "03"].includes(this.state.formValues.tipoComprobante)) {

                    var NotaCredito = await pagoService.obtenerCompraNroSerie(cliente[0].id);
                    NotaCredito = NotaCredito.filter(e => e.tipoComprobante == this.state.formValues.tipoComprobante);

                    this.setState({
                        viewCredito: true,
                        listaCredito: NotaCredito ? NotaCredito : [],
                        formValues: {
                            ...this.state.formValues,
                            listaCredito: NotaCredito ? NotaCredito : [],
                            identifier: identifier
                        }
                    })
                } else {
                    dialog.error('La nota de crédito solo aplica para Factura o Boleta');
                    return false;
                }

            } else {

                if (this.state.formValues.activeKey == "1") {
                    this.state.formValues.listaFormaPago.forEach(element => {
                        if (element.identifier == identifier) {
                            element.idMetodoPago = value
                        }
                    });
                }
                if (this.state.formValues.activeKey == "3") {
                    this.state.formValues.listaFormaPagoOtros.forEach(element => {
                        if (element.identifier == identifier) {
                            element.idMetodoPago = value
                        }
                    });
                }

            }

        }

        if (property == "idMonto") {
            var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;
            var tipoCambio = this.state.formValues.tipoCambio;
            var valorNuevo = [];
            var montoNuevo = 0;
            var formaPago = this.state.formValues.activeKey == "1" ? this.state.formValues.listaFormaPago.filter(e => e.identifier == identifier) :
                this.state.formValues.listaFormaPagoOtros.filter(e => e.identifier == identifier);

            if (this.state.formValues.listaFormaPago.length == 2) {

                if (moneda == 2) { //cuando el documento es dolares
                    if (formaPago[0].idMoneda == moneda) {

                        montoNuevo = ((this.state.formValues.Saldo - value) * tipoCambio).toFixed(2);

                    } else {
                        montoNuevo = (value / tipoCambio).toFixed(2)
                        montoNuevo = (this.state.formValues.Saldo - montoNuevo).toFixed(2);
                    }

                } else {

                    if (formaPago[0].idMoneda == moneda) {
                        montoNuevo = (this.state.formValues.Saldo - value).toFixed(2);
                        montoNuevo = (montoNuevo / tipoCambio).toFixed(2)

                    } else {

                        montoNuevo = (this.state.formValues.Saldo - (value * tipoCambio)).toFixed(2);

                    }

                }

                this.state.formValues.listaFormaPago.forEach((key, index) => {

                    if (key.identifier == identifier) {

                        var dataNueva = {
                            identifier: global.fetchUniqueCode(),
                            fecha: key.fecha,
                            idMetodoPago: 4,
                            idDestino: 0,
                            nroDocumento: '',
                            idBanco: 0,
                            idMoneda: formaPago[0].idMoneda == 1 ? 1 : 2,  //SOLES ? DOLARES
                            referencia: formaPago[0].referencia,
                            montoCuota: parseFloat(value),
                            montoRecibido: 0,
                            montoVuelto: 0
                        };
                        valorNuevo.splice(index, 0, dataNueva);


                    } else {
                        var dataNueva = {
                            identifier: global.fetchUniqueCode(),
                            fecha: key.fecha,
                            idMetodoPago: 4,
                            idDestino: 0,
                            nroDocumento: '',
                            idBanco: 0,
                            idMoneda: formaPago[0].idMoneda == 1 ? 2 : 1,  //SOLES ? DOLARES
                            referencia: formaPago[0].referencia,
                            montoCuota: parseFloat(montoNuevo),
                            montoRecibido: 0,
                            montoVuelto: 0
                        };
                        valorNuevo.splice(index, 0, dataNueva);


                    }



                });

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPago: valorNuevo,
                    }
                });

            } else {


                if (this.state.formValues.activeKey == "1") {
                    var dataNueva = {
                        identifier: global.fetchUniqueCode(),
                        fecha: formaPago[0].fecha,
                        idMetodoPago: 4,
                        idDestino: 0,
                        nroDocumento: '',
                        idBanco: 0,
                        idMoneda: formaPago[0].idMoneda == 1 ? 1 : 2,  //SOLES ? DOLARES
                        referencia: formaPago[0].referencia,
                        montoCuota: parseFloat(value),
                        montoRecibido: 0,
                        montoVuelto: 0
                    };

                    valorNuevo.splice(index, 0, dataNueva);


                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaFormaPago: valorNuevo,
                        }
                    });
                } else {

                    var valorNuevo = this.state.formValues.listaFormaPagoOtros.filter(e => e.identifier != identifier);

                    var dataNueva = {
                        identifier: global.fetchUniqueCode(),
                        fecha: formaPago[0].fecha,
                        idMetodoPago: formaPago[0].idMetodoPago,
                        idDestino: formaPago[0].idDestino,
                        nroDocumento: formaPago[0].nroDocumento,
                        idBanco: formaPago[0].idBanco,
                        idMoneda: formaPago[0].idMoneda == 1 ? 1 : 2,  //SOLES ? DOLARES
                        referencia: formaPago[0].referencia,
                        montoCuota: parseFloat(value),
                        montoRecibido: formaPago[0].montoRecibido,
                        montoVuelto: formaPago[0].montoVuelto
                    };

                    valorNuevo.splice(index, 0, dataNueva);


                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaFormaPagoOtros: valorNuevo,
                        }
                    });
                }

            }

        }

        if (property == "idMoneda") {

            if (this.state.formValues.activeKey == "2") {

                var formaPago = this.state.formValues.listaFormaPagoCredito.filter(e => e.identifier != identifier);
                var pagoOld = this.state.formValues.listaFormaPagoCredito.filter(e => e.identifier == identifier);

                var dataNueva = {
                    identifier: global.fetchUniqueCode(),
                    fecha: pagoOld[0].fecha,
                    idMetodoPago: pagoOld[0].idMetodoPago,
                    idDestino: 0,
                    nroDocumento: pagoOld[0].nroDocumento,
                    idBanco: 0,
                    idMoneda: value,
                    referencia: pagoOld[0].referencia,
                    montoCuota: pagoOld[0].montoCuota,
                    montoRecibido: pagoOld[0].montoRecibido,
                    montoVuelto: pagoOld[0].montoVuelto
                };

                formaPago.splice(index, 0, dataNueva);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPagoCredito: formaPago
                    }
                });
                return;
            }
            if (this.state.formValues.listaFormaPago.length == 1) {

                var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;

                var montoCuota = 0;
                if (moneda == value) {

                    montoCuota = this.state.formValues.Saldo;
                } else {
                    montoCuota = this.state.formValues.Monto;

                }

                var formaPago = [];
                formaPago.push({
                    identifier: global.fetchUniqueCode(),
                    fecha: this.state.formValues.listaFormaPago[0].fecha,
                    idMetodoPago: 4,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: value,  //SOLES ? DOLARES
                    referencia: '',
                    montoCuota: parseFloat(montoCuota),
                    montoRecibido: 0,
                    montoVuelto: 0
                });


                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPago: formaPago,
                    }
                });

            } else {

                var formaPago = this.state.formValues.listaFormaPago.filter(e => e.identifier != identifier);
                var dataNueva = {
                    identifier: global.fetchUniqueCode(),
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: 4,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: this.state.formValues.listaFormaPago[0] == 1 ? 2 : 1,  //SOLES ? DOLARES
                    referencia: '',
                    montoCuota: 0,
                    montoRecibido: 0,
                    montoVuelto: 0
                };

                formaPago.splice(index, 0, dataNueva);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPago: formaPago
                    }
                });

            }


        }



        if (property == "idReferencia") {

            this.state.formValues.listaFormaPagoOtros.forEach(element => {
                if (element.identifier == identifier) {
                    element.referencia = value;
                }
            });

        }

        if (property == "arrDocumento") {

            this.state.formValues.listaFormaPagoCredito.forEach(element => {
                if (element.identifier == identifier) {
                    element.nroDocumento = value;
                }
            });

        }
        if (property == "arrMontoCuota") {

            if (this.state.formValues.activeKey == "2") {
                this.state.formValues.listaFormaPagoCredito.forEach(element => {
                    if (element.identifier == identifier) {
                        element.montoCuota = parseFloat(value);

                    }
                });
            }

        }

    };

    onOtrosPago = (element, form) => {


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPagoOtros: element,
            }
        });

    }

    //endregion Imprimir

    handleSelectCredito = (row, item) => {
        debugger
        if (row.length == 1) {

            var id = item[0].idCuentasPagarDetalle;
            const posicion = item[0].flagDetraccion ? 0 : this.state.formValues.listaDetalleCredito.findIndex(elemento => elemento.idCuentasPagarDetalle === id);

            if (posicion != 0) {
                dialog.error('No se puede realizar el cobro ... Tiene que seleccionar cuotas en forma ordenada');
                return false;
            }

            var moneda = item[0].moneda;
            moneda = moneda.charAt(0);

            this.setState({
                loadingVer: false,
                viewVisible: false,
                formValues: {
                    ...this.state.formValues,
                    idCuentasPagar: item[0].id,
                    activeKey: "3",
                    idCuentasPagarDetalle: item[0].idCuentasPagarDetalle,
                    Moneda: item[0].moneda,
                    Monto: moneda == "D" ? (item[0].montoCuota * item[0].tipoCambio) : (item[0].montoCuota / item[0].tipoCambio),
                    nroCouta: item[0].couta.replace('CUOTA', ''),
                    Fecha: item[0].fechaStr,
                    tipoCambio: item[0].tipoCambio,
                    Saldo: item[0].montoCuota,
                    flagPago: false,
                    formaPago: item[0].formaPago,
                    flagCredito: item[0].idFormaPago == 2 ? true : false,
                    flagDetraccion: item[0].flagDetraccion,
                    listaComprobanteMasivo: [],
                    listaMetodoPago: this.state.listaMetodoPago,
                    listaCuentaDestino: this.state.listaCuentaDestino,
                    listaFormaPagoCredito: [],
                    listaBanco: this.state.listaBanco,
                    listaMoneda: this.state.listaMoneda,
                    selectedRowKeys: row
                }
            });
            return true;
        }

        if (row.length == 0) {
            this.setState({
                loadingVer: false,
                viewVisible: false,
                formValues: {
                    ...this.state.formValues,
                    selectedRowKeys: [],
                }
            });
            return true;
        }

        else {
            dialog.error('Solo se puede seleccionar una cuota');
            return false
        }
    };

    handleClosePago = async () => {
        this.setState({
            loadingVer: false,
            viewVisible: false,
            loadingPago: false,
            viewPagoCreditoVisible: false,
            formValues: {
                ...this.state.formValues,
                selectedRowKeys: [],
                flagDetraccion: false,
            }
        });

    }

    handleNextPago = async (item, form) => {
        if (this.state.formValues.selectedRowKeys.length == 0) {
            dialog.warning("Seleccione cuota a pagar");
            return false;
        }
        this.setState({
            loadingVer: false,
            viewVisible: false,
            loadingPago: false,
            viewPagoVisible: true,
            viewPagoCreditoVisible: false,
            formValues: {
                ...this.state.formValues,
                selectedRowKeys: [],
            }
        });

    }
    async componentDidMount() {
        const empresa = await empresaService.obtenerPrincipal(0);

        const metodoPagos = await metodoPagoService.listar();
        const cuentaDestino = await cuentaService.listar_select();
        const estadoPagar = await cuentasPagarService.listar_estados();
        const bancos = await bancoService.listarBancoCuentas();
        const monedas = await monedaService.listar();

        this._initPagination({ ...this.state.filter }, pagoService.pago_proveedores);


        const clientes = await proveedorService.listar();

        this.setState({
            loadingSource: false,
            clientes: clientes ? clientes : [],
            listaMetodoPago: metodoPagos ? metodoPagos : [],
            listaCuentaDestino: cuentaDestino ? cuentaDestino : [],
            listaEstadoPago: estadoPagar ? estadoPagar : [],
            listaBanco: bancos ? bancos : [],
            listaMoneda: monedas ? monedas : [],
            company: empresa,
        });
    }

    render() {
        return (
            <div>

                <Header
                    title="Pago a Proveedores"
                    onReturn={this.onReturn}
                    onPagar={this.onPagar}
                    isRegresar={this.state.isRegresar}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                    isPagar={this.state.isPagar}

                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    estado={this.state.listaEstadoPago}
                    comprobantes={this.state.listaTipoComprobante}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    isCabecera={this.state.isCabecera}
                    isDisabled={this.state.isDisabled}

                />
                {this.state.ListCabecera ?
                    <ResultList
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        loadingPrint={this.state.loadingPrint}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onHistorial={this.handleHistorial}
                        onChange={this._handleChangePagination}
                        onViewPago={this.handleViewPago}

                    />
                    :
                    <ResultListDetalle
                        visible={this.state.ListDetalle}
                        pagination={this.state.pagination}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        loadingPrint={this.state.loadingPrint}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onChange={this._handleChangePagination}
                        onViewPago={this.handleViewPago}
                        onChangeRow={this.handleChangeSelectedRowKey}

                    />
                }


                <ViewPago
                    onRemoverFormaPago={this.handleRemoverFormaPago}
                    onAgregarDetalle={this.handleAddFormaPago}
                    onSave={this.handleSave}
                    visible={this.state.viewPagoVisible}
                    visibleDetalle={this.state.viewPagoDetalle}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewPagoVisible: false })}
                    onChangePago={this.handleChangePago}
                    onChangeTab={this.handleChangeTab}
                    onSwitch={this.onSwitch}
                    onOtrosPago={this.onOtrosPago}

                />

                <ViewPagoCredito
                    visible={this.state.viewPagoCreditoVisible}
                    formValues={this.state.formValues}
                    onChangeRow={this.handleSelectCredito}
                    onClose={this.handleClosePago}
                    onNext={this.handleNextPago}
                />

                <SearchCreditoModal
                    visible={this.state.viewCredito}
                    formValues={this.state.formValues}
                    onCancel={() => this.setState({ viewCredito: false })}
                    dataSource={this.state.formValues.listaCredito}
                    onSelect={this.handleSelectProduct}
                />
            </div>
        );
    };
}